import styled from 'styled-components'
import colors from '../../../configuration/colors'

export default styled.button.attrs(props => ({
  className: `${props.className ?? ''} quest-btn btn-c ${props.disabled ? 'disabled' : ''}`
}))`
  width: ${props => props.fixedWidth ? '104px' : 'max-content'};
  height: ${props => props.height ?? '40px'};
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  line-height: 1;

  border: 1px solid ${colors.aluminum};
  background: transparent;
  color: ${props => props.theme.h4};

  &:focus,
  &:hover {
    border: 1px solid ${props => props.theme.maxContrast};
    color: ${props => props.theme.highContrastText};
  }
`
